module.exports = __webpack_public_path__ + "media/images/glw-eb5f554435eca483cc465808fe35c0ee.jpg";